<template>
    <div class="error_page">
        <div class="error_page_block">
            <div class="error_page_code_block">
                <span class="error_page_code">
                    {{ error.statusCode }}
                </span>
            </div>
            <div class="error_page_text_block">
                <span v-if="error.statusCode === 404" class="error_page_text">
                    Извините, страница не найдена.
                </span>
                <span v-else class="error_page_text">
                    {{ error.message }}
                </span>
            </div>
            <NuxtLink to="/" class="home-button">
                На главную
            </NuxtLink>
            <div v-if="env.MODE === `development`">
                ENV:
                <pre>{{ env }}</pre>
                runtimeConfig:
                <pre>{{ runtimeConfig }}</pre>
                stack:
                <pre>{{ error.stack }}</pre>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRuntimeConfig } from '#app';

defineProps({
    error: {
        type: Object,
        default: () => ({}),
    },
});

const runtimeConfig = useRuntimeConfig();
const env = import.meta.env;
</script>

<style scoped>
.error_page {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f8f8;
    font-family: Arial, sans-serif;
}

.error_page_block {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 12px;
    text-align: center;
    padding: 2rem;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.error_page_code {
    font-size: 8em;
    color: #e4003c;
    font-weight: bold;
    margin-bottom: 0.5rem;
}

.error_page_text {
    font-size: 1.5em;
    color: #333;
    margin-bottom: 2rem;
}

.home-button {
    border-radius: 6px;
    border: none;
    min-width: 193px;
    height: 56px;
    padding: 16px 28px;
    background-color: #E4003C;
    color:#FFFFFF;
    text-decoration: none;
}

</style>
